/*
 * @Author: wblijinyang
 * @FilePath: /code/mall-fe/src/views/web/product/conponents/agreement-enums.ts
 * @Description: 交易规则枚举文件
 */
export const accountPeriodTypes = [
  { value: 2, label: '先款后货', seq: 3, netPriceAttr: 'beforePaymentNetPriceDate' },
  { value: 1, label: '货到付款', seq: 1, netPriceAttr: 'afterPaymentNetPriceDate' },
  { value: 3, label: '预付款', seq: 4, netPriceAttr: 'prePaymentNetPriceDate' },
  { value: 0, label: '结算付款', seq: 2, netPriceAttr: 'customNetPriceDate' },
];

export const findEnum = (collection, value) => {
  return collection.find((v) => v.value === value) || {};
};

export const getCircleNum = (n) => {
  if (n < 0 || n > 20) {
    return n;
  } else {
    return String.fromCharCode(9312 + n - 1);
  }
};

export const newAccountPeriodTypes = {
  CashBeforeDelivery: {
    value: 2,
    label: '先款后货。即下单后先全额支付货款，再安排发货。',
    seq: 3,
  },
  CashOnDelivery: {
    value: 1,
    label: '货到付款。即完成收货后基于订单安排付款，无需走结算对账流程。',
    seq: 1,
  },
  PrePay: {
    value: 3,
    label:
      '预付款。即下单后先按约定比例预付货款，再安排发货；完成收货后基于订单、按实际收货金额结清货款。',
    seq: 4,
  },
  SettlementPay: {
    value: 0,
    label: '结算付款。即完成收货后，需要进行结算对账流程，再安排付款。',
    seq: 2,
  },
};

export const afterPaymentConfigPaymentMode = {
  All: {
    value: 1,
    label: '一次性全额付款',
  },
  Part: {
    value: 2,
    label: '分期付款',
  },
};

export const settlementIntervalEnum = {
  Day: {
    value: 1,
    label: '日结',
  },
  Week: {
    value: 2,
    label: '周结',
  },
  Month: {
    value: 3,
    label: '月结',
  },
};

export const weekData = {
  One: {
    label: '周一',
    value: 1,
  },
  Two: {
    label: '周二',
    value: 2,
  },
  Three: {
    label: '周三',
    value: 3,
  },
  FOUR: {
    label: '周四',
    value: 4,
  },
  FIVE: {
    label: '周五',
    value: 5,
  },
  Six: {
    label: '周六',
    value: 6,
  },
  Seven: {
    label: '周日',
    value: 7,
  },
};

export const settlementConfigBillingPeriodList = {
  DAY_0: {
    value: 0,
    label: '立即付款',
  },
  DAY_7: {
    value: 1,
    label: '7天后一次性付款',
  },
  MONTH_1: {
    value: 2,
    label: '1个月后一次性付款',
  },
  MONTH_2: {
    value: 5,
    label: '2个月后一次性付款',
  },
  MONTH_3: {
    value: 3,
    label: '3个月后一次性付款',
  },
  MONTH_6: {
    value: 4,
    label: '6个月后一次性付款',
  },
  MONTH_4: {
    value: 8,
    label: '4个月后一次性付款',
  },
  MONTH_5: {
    value: 9,
    label: '5个月后一次性付款',
  },
  OTHER: {
    value: 6,
    label: '一次性付款，其他',
  },
  PART: {
    value: 7,
    label: '分期付款',
  },
};

export const questionMarkMap = {
  1: 2,
  2: 3,
  3: 7,
};

export const pricingModelEnum = {
  Sales: { value: 1, label: '依据店铺销售价格浮动定价' },
  Information: { value: 2, label: '商品砼，基于信息价定价' },
  RebarNet: { value: 3, label: '钢筋，安装钢材网价协议模板' },
  Custom: { value: 4, label: '商品砼，自定义价格' },
  Material: { value: 5, label: '安装材料计价模板' },
  Agreement: { value: 6, label: '固定协议价' },
  Aluminum: { value: 7, label: '铝型材料定价模版' },
};

export const templatePriceConfigQuoteMode = {
  PreTax: { value: 1, label: '除税价格' },
  IncluedTax: { value: 2, label: '含税价格' },
};

export const DiscountTypeEnum = {
  RATIO: {
    value: 1,
    label: '浮动比例',
  },
  NUMBER: {
    value: 2,
    label: '浮动金额',
  },
};

const modelDiscountListRenderInstruct = [
  {
    dataIndex: 'categoryName',
    title: '类别',
    align: 'center',
    width: '120px',
  },
  {
    dataIndex: 'attribute',
    title: '属性',
    width: '120px',
    align: 'center',
  },
  {
    dataIndex: 'attributeValue',
    title: '属性值',
    align: 'center',
    width: '120px',
  },
  {
    dataIndex: 'discountType',
    title: '浮动加（减）价',
    width: '156px',
    align: 'center',
    render: function (_, data) {
      var unit = '';
      var typeStr = '';
      if (data.discountTypeEnum === DiscountTypeEnum.RATIO.value) {
        unit = '%';
        typeStr = DiscountTypeEnum.RATIO.label;
      } else {
        unit = '元';
        typeStr = DiscountTypeEnum.NUMBER.label;
      }
      return typeStr + data.discount + unit;
    },
  },
  {
    dataIndex: 'formulaString',
    title: '单价计价公式',
    width: '156px',
    align: 'center',
  },
];
const brandDiscountListRenderInstruct = [
  {
    dataIndex: 'brandName',
    title: '品牌',
    width: '200px',
    align: 'center',
    render: function (_, data) {
      return (data.brandList?.map((v) => v.name) || []).join('、');
    },
  },
  {
    dataIndex: 'formula',
    title: '单价计价公式类型',
    width: '200px',
    align: 'center',
  },
  {
    dataIndex: 'formulaString',
    title: '单价计价公式',
    width: '272px',
    align: 'center',
  },
];

const unloadingDiscountListRenderInstruct = [
  {
    dataIndex: 'attributeValue',
    title: '条件',
    width: '200px',
    align: 'center',
  },
  {
    dataIndex: 'discount',
    title: '浮动加（减）价',
    width: '200px',
    align: 'center',
  },
  {
    dataIndex: 'formulaString',
    title: '单价计价公式',
    width: '272px',
    align: 'center',
  },
];
const transportDistanceDiscountRenderInstruct = [
  {
    dataIndex: 'price',
    title: '条件',
    width: '300px',
    align: 'center',
    render: function () {
      return '按照距离计价，距离为用户下单时手动填写';
    },
  },
  {
    dataIndex: 'price',
    title: '单价',
    width: '200px',
    align: 'center',
    render: function (_, data) {
      return data.price + '元/km·t';
    },
  },
  {
    dataIndex: 'formulaString',
    title: '单价计价公式',
    width: '272px',
    align: 'center',
  },
];
export const priceFloatList = [
  {
    label: '按规格型号浮动',
    columns: modelDiscountListRenderInstruct,
    dataSourceAttr: 'modelDiscountList',
  },
  {
    label: '按品牌浮动',
    columns: brandDiscountListRenderInstruct,
    dataSourceAttr: 'brandDiscountList',
  },
  {
    label: '卸车',
    columns: unloadingDiscountListRenderInstruct,
    dataSourceAttr: 'unloadingDiscountList',
  },
  {
    label: '运距',
    columns: transportDistanceDiscountRenderInstruct,
    dataSourceAttr: 'transportDistanceDiscount',
  },
];

export const aluminumPriceFloatList = [
  {
    label: '卸车',
    columns: unloadingDiscountListRenderInstruct,
    dataSourceAttr: 'unloadingDiscountList',
  },
  {
    label: '运距',
    columns: transportDistanceDiscountRenderInstruct,
    dataSourceAttr: 'transportDistanceDiscount',
  },
]

export const mixingStationRenderInstruct = [
  {
    dataIndex: 'supplierName',
    title: '供应商',
    width: '200px',
    align: 'center',
  },
  {
    dataIndex: 'stationNameList',
    title: '搅拌站',
    width: '200px',
    align: 'center',
    render: function (_, data) {
      return data.stationNameList?.join('、') || '--';
    },
  },
];

export const discountTypeEnum = {
  Ratio: {
    value: 1,
    label: '浮动比例',
  },
  Amount: {
    value: 2,
    label: '浮动金额',
  },
};

export const doubleAttributeConfigListRenderInstruct = [
  {
    dataIndex: 'kangzhe',
    title: '货品名称',
    width: '200px',
    align: 'center',
    render: function () {
      return '抗折商品砼';
    },
  },
  {
    dataIndex: 'discount',
    title: '强度等级',
    width: '200px',
    align: 'center',
    render: function (_, data) {
      return data.attributeValueList.join(', ');
    },
  },
  {
    dataIndex: 'normalAttributeValue',
    title: '基价-普通混凝土',
    width: '200px',
    align: 'center',
  },
  {
    dataIndex: 'discount',
    title: '浮动加（减）价',
    width: '200px',
    align: 'center',
  },
  {
    dataIndex: 'jiaozhufangshi',
    title: '单价计价公式',
    width: '200px',
    align: 'center',
    render: function (_, data) {
      var val =
        data.discount === 0
          ? ''
          : data.discount > 0
          ? ' + ' + data.discount
          : ' - ' + Math.abs(data.discount);
      return data.normalAttributeValue + '价格' + val;
    },
  },
];

export const priceRuleList = {
  Ratio: { label: "按价格波动比例调价", value: 1 },
  Section: { label: "按价格波动区间调价", value: 2 },
}